import { Chart } from "@antv/g2";
import * as _ from "@antv/util";
import React, { useEffect, useRef } from "react";
import { theme } from "antd";

export default function EmptyDoughnutChart({
  data = [{ type: "", percent: 0, color: "#e8e8e8" }],
  x = "type",
  y = "percent",
  color = "color",
  chartTextValue = "percent",
  innerRadius = 0.5,
  outerRadius = 0.8,
  tooltipFunction = (data) => ({
    name: data.type,
    value: data.percent,
  }),
}) {
  const container = _.uniqueId("emptydoughnutchart-");
  const chartRef = useRef(null);
  const { token } = theme.useToken();

  useEffect(() => {
    chartRef.current?.clear();
    const chartContainer = document.getElementById(container);
    chartContainer.innerHTML = "";
    const chart = new Chart({
      container: container,
      padding: "auto",
      autoFit: true,
    });

    const facetRect = chart
      .facetRect()
      .data(data)
      .encode("x", x)
      .axis(false)
      .legend(false)
      .view()
      .attr("frame", false)
      .coordinate({
        type: "theta",
        innerRadius: innerRadius,
        outerRadius: outerRadius,
      });

    facetRect
      .interval()
      .encode("y", 100)
      .scale("y", { zero: true })
      .style("fill", "#e8e8e8")
      .tooltip(false)
      .animate(false);

    facetRect
      .text()
      .encode("text", x)
      .style("textAlign", "center")
      .style("textBaseline", "middle")
      .style("fontSize", 20)
      .style("color", "#8c8c8c")
      .style("fill", token.colorTextBase)
      .style("x", "50%")
      .style("y", "50%")
      .style("dy", -20);

    facetRect
      .text()
      .encode("text", chartTextValue)
      .style("textAlign", "center")
      .style("textBaseline", "middle")
      .style("fontSize", 30)
      .style("fontWeight", 500)
      .style("color", "#000")
      .style("fill", token.colorTextBase)
      .style("x", "50%")
      .style("y", "50%")
      .style("dy", 20);

    chart.render();

    chartRef.current = chart;

    return () => {
      chartRef.current?.destroy();
    };
  }, [token, data]);

  useEffect(() => {
    const chartContainer = document.getElementById(container);
    const resizeObserver = new ResizeObserver(() => {});

    resizeObserver.observe(chartContainer);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <>
      <div id={container} style={{ height: "100%", width: "100%" }}></div>
    </>
  );
}
